import { EntityState, EntityAdapter, createEntityAdapter } from '@ngrx/entity';
import { DeviceMonitoringActions, DeviceMonitoringActionTypes } from '../actions/device-monitoring.actions';
import {DeviceMonitoringData} from '../../../models/devices';
import {FloorMap} from '../../floor-map/floor-map.model';

export interface State extends EntityState<DeviceMonitoringData> {
  Loading: boolean;
  Loaded: boolean;
  // entities: DeviceMonitoringData[];
}

export const adapter: EntityAdapter<DeviceMonitoringData> = createEntityAdapter<DeviceMonitoringData>({
  selectId: model => model.dcode
});

export const initialState: State = adapter.getInitialState({
  Loading: false,
  Loaded: false,
  // entities: []
});

export function reducer(state = initialState, action: DeviceMonitoringActions): State {
  switch (action.type) {

    case DeviceMonitoringActionTypes.GetDeviceMonitorings: {
      return {...state, Loaded: false, Loading: true};
    }
    case DeviceMonitoringActionTypes.LoadDeviceMonitorings: {
      return adapter.setAll(action.payload.deviceMonitorings,
        {...state, Loaded: true, Loading: false});
      // return {...state, Loaded: true, Loading: false, entities: action.payload};
    }

    case DeviceMonitoringActionTypes.GetDeviceMonitoringsFail: {
        return {...state, Loaded: true, Loading: false};
    }

    case DeviceMonitoringActionTypes.UpsertDeviceMonitorings: {
      return adapter.upsertMany(action.payload.deviceMonitorings,
        {...state, Loaded: true, Loading: false});
    }

    case DeviceMonitoringActionTypes.NoDeviceMonitoringsChanged: {
      return {...state, Loaded: true, Loading: false};
    }

    default: {
      return state;
    }
  }
}

export const {
  selectIds,
  selectEntities,
  selectAll,
  selectTotal,
} = adapter.getSelectors();
